// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --clr: #6A9E2C;
  --clr-hover: #8CC63E;
  --card-bg: rgba(255, 255, 255, 0.85);
  --card-border: rgba(255, 255, 255, 0.6);
  --shadow-card: 0 20px 60px rgba(0, 0, 0, 0.25), 0 4px 12px rgba(0, 0, 0, 0.1);
}

.logout-container {
  position: relative;
  min-height: 100vh;
  width: 100vw;
  margin: 0;
  padding: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  overflow: hidden;
}

.logout-container::before {
  content: "";
  position: absolute;
  inset: 0;
  background: linear-gradient(
    135deg,
    rgba(106, 158, 44, 0.15) 0%,
    rgba(0, 0, 0, 0.25) 60%,
    rgba(0, 0, 0, 0.35) 100%
  );
  pointer-events: none;
  z-index: 0;
}

.logout-content {
  flex: 1 1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 1;
  padding: 24px;
}

.logout-card {
  width: 100%;
  max-width: 440px;
  background: var(--card-bg);
  backdrop-filter: blur(18px) saturate(160%);
  -webkit-backdrop-filter: blur(18px) saturate(160%);
  border-radius: 24px;
  border: 1px solid var(--card-border);
  box-shadow: var(--shadow-card);
  padding: 44px 36px 32px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.1rem;
  animation: cardFadeIn 0.7s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes cardFadeIn {
  from { opacity: 0; transform: translateY(24px) scale(0.97); }
  to   { opacity: 1; transform: translateY(0) scale(1); }
}

.success-circle {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: radial-gradient(circle at 30% 30%, rgba(140, 198, 62, 0.18), rgba(106, 158, 44, 0.08));
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  animation: pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;
}

.success-circle::after {
  content: "";
  position: absolute;
  inset: -8px;
  border-radius: 50%;
  border: 2px solid rgba(106, 158, 44, 0.35);
  animation: pulse 2.2s ease-out infinite;
}

@keyframes pop {
  0%   { opacity: 0; transform: scale(0.4); }
  100% { opacity: 1; transform: scale(1); }
}

@keyframes pulse {
  0%   { transform: scale(0.95); opacity: 0.7; }
  70%  { transform: scale(1.15); opacity: 0; }
  100% { transform: scale(1.15); opacity: 0; }
}

.success-check {
  width: 72px;
  height: 72px;
}

.success-check circle {
  stroke: var(--clr);
  stroke-width: 2.5;
  stroke-dasharray: 166;
  stroke-dashoffset: 166;
  animation: drawCircle 0.7s cubic-bezier(0.65, 0, 0.45, 1) 0.15s forwards;
}

.success-check path {
  stroke: var(--clr);
  stroke-width: 4;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-dasharray: 48;
  stroke-dashoffset: 48;
  animation: drawCheck 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.7s forwards;
}

@keyframes drawCircle { to { stroke-dashoffset: 0; } }
@keyframes drawCheck  { to { stroke-dashoffset: 0; } }

.logout-text {
  text-align: center;
  margin: 2px 0 4px;
}

.logout-text h1 {
  margin: 0;
  font-size: 1.45rem;
  font-weight: 700;
  color: #2c2c2c;
  letter-spacing: -0.01em;
}

.logout-text p {
  margin: 8px 0 0;
  font-size: 0.92rem;
  color: #6b6b6b;
  line-height: 1.4;
}

.logout-brand {
  margin-top: -4px;
  opacity: 0.95;
}

.logout-brand img {
  max-width: 110px;
  height: auto;
  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.08));
}

.logout-countdown {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}

.logout-countdown-bar {
  width: 100%;
  height: 6px;
  border-radius: 999px;
  background: rgba(106, 158, 44, 0.15);
  overflow: hidden;
}

.logout-countdown-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--clr), var(--clr-hover));
  border-radius: 999px;
  transition: width 1s linear;
}

.logout-countdown span {
  font-size: 0.78rem;
  color: #6b6b6b;
  letter-spacing: 0.02em;
}

.logout-actions {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 8px;
  margin-top: 6px;
}

.btn-logout-secondary {
  background: transparent;
  border: none;
  color: #7a7a7a;
  font-size: 0.82rem;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 8px;
  transition: color 200ms ease, background-color 200ms ease;
  letter-spacing: 0.02em;
}

.btn-logout-secondary:hover {
  color: var(--clr);
  background: rgba(106, 158, 44, 0.06);
}

.logout-footer {
  width: 100%;
  text-align: center;
  padding: 14px 16px;
  position: relative;
  z-index: 1;
  background: rgba(0, 0, 0, 0.55);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}

.logout-footer span {
  color: #ffffff;
  font-size: 0.8rem;
  letter-spacing: 0.02em;
  opacity: 0.9;
}

@media (max-width: 480px) {
  .logout-card {
    padding: 34px 22px 26px;
    border-radius: 20px;
  }
  .logout-text h1 { font-size: 1.2rem; }
  .success-circle { width: 84px; height: 84px; }
  .success-check  { width: 62px; height: 62px; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/logout/LogoutPageStyles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,oBAAoB;EACpB,oCAAoC;EACpC,uCAAuC;EACvC,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR;;;;;GAKC;EACD,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,0CAA0C;EAC1C,kDAAkD;EAClD,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,wDAAwD;AAC1D;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kGAAkG;EAClG,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,+DAA+D;AACjE;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE,qBAAqB,EAAE;EAC1C,OAAO,UAAU,EAAE,mBAAmB,EAAE;AAC1C;;AAEA;EACE,OAAO,sBAAsB,EAAE,YAAY,EAAE;EAC7C,OAAO,sBAAsB,EAAE,UAAU,EAAE;EAC3C,OAAO,sBAAsB,EAAE,UAAU,EAAE;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;EACtB,wEAAwE;AAC1E;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,oBAAoB;EACpB,qBAAqB;EACrB,sEAAsE;AACxE;;AAEA,wBAAwB,KAAK,oBAAoB,EAAE,EAAE;AACrD,wBAAwB,KAAK,oBAAoB,EAAE,EAAE;;AAErD;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,gEAAgE;EAChE,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yDAAyD;EACzD,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE;IACE,uBAAuB;IACvB,mBAAmB;EACrB;EACA,kBAAkB,iBAAiB,EAAE;EACrC,kBAAkB,WAAW,EAAE,YAAY,EAAE;EAC7C,kBAAkB,WAAW,EAAE,YAAY,EAAE;AAC/C","sourcesContent":[":root {\n  --clr: #6A9E2C;\n  --clr-hover: #8CC63E;\n  --card-bg: rgba(255, 255, 255, 0.85);\n  --card-border: rgba(255, 255, 255, 0.6);\n  --shadow-card: 0 20px 60px rgba(0, 0, 0, 0.25), 0 4px 12px rgba(0, 0, 0, 0.1);\n}\n\n.logout-container {\n  position: relative;\n  min-height: 100vh;\n  width: 100vw;\n  margin: 0;\n  padding: 0;\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  align-items: center;\n  overflow: hidden;\n}\n\n.logout-container::before {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(\n    135deg,\n    rgba(106, 158, 44, 0.15) 0%,\n    rgba(0, 0, 0, 0.25) 60%,\n    rgba(0, 0, 0, 0.35) 100%\n  );\n  pointer-events: none;\n  z-index: 0;\n}\n\n.logout-content {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n  padding: 24px;\n}\n\n.logout-card {\n  width: 100%;\n  max-width: 440px;\n  background: var(--card-bg);\n  backdrop-filter: blur(18px) saturate(160%);\n  -webkit-backdrop-filter: blur(18px) saturate(160%);\n  border-radius: 24px;\n  border: 1px solid var(--card-border);\n  box-shadow: var(--shadow-card);\n  padding: 44px 36px 32px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1.1rem;\n  animation: cardFadeIn 0.7s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n@keyframes cardFadeIn {\n  from { opacity: 0; transform: translateY(24px) scale(0.97); }\n  to   { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n.success-circle {\n  width: 96px;\n  height: 96px;\n  border-radius: 50%;\n  background: radial-gradient(circle at 30% 30%, rgba(140, 198, 62, 0.18), rgba(106, 158, 44, 0.08));\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  animation: pop 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.1s both;\n}\n\n.success-circle::after {\n  content: \"\";\n  position: absolute;\n  inset: -8px;\n  border-radius: 50%;\n  border: 2px solid rgba(106, 158, 44, 0.35);\n  animation: pulse 2.2s ease-out infinite;\n}\n\n@keyframes pop {\n  0%   { opacity: 0; transform: scale(0.4); }\n  100% { opacity: 1; transform: scale(1); }\n}\n\n@keyframes pulse {\n  0%   { transform: scale(0.95); opacity: 0.7; }\n  70%  { transform: scale(1.15); opacity: 0; }\n  100% { transform: scale(1.15); opacity: 0; }\n}\n\n.success-check {\n  width: 72px;\n  height: 72px;\n}\n\n.success-check circle {\n  stroke: var(--clr);\n  stroke-width: 2.5;\n  stroke-dasharray: 166;\n  stroke-dashoffset: 166;\n  animation: drawCircle 0.7s cubic-bezier(0.65, 0, 0.45, 1) 0.15s forwards;\n}\n\n.success-check path {\n  stroke: var(--clr);\n  stroke-width: 4;\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-dasharray: 48;\n  stroke-dashoffset: 48;\n  animation: drawCheck 0.4s cubic-bezier(0.65, 0, 0.45, 1) 0.7s forwards;\n}\n\n@keyframes drawCircle { to { stroke-dashoffset: 0; } }\n@keyframes drawCheck  { to { stroke-dashoffset: 0; } }\n\n.logout-text {\n  text-align: center;\n  margin: 2px 0 4px;\n}\n\n.logout-text h1 {\n  margin: 0;\n  font-size: 1.45rem;\n  font-weight: 700;\n  color: #2c2c2c;\n  letter-spacing: -0.01em;\n}\n\n.logout-text p {\n  margin: 8px 0 0;\n  font-size: 0.92rem;\n  color: #6b6b6b;\n  line-height: 1.4;\n}\n\n.logout-brand {\n  margin-top: -4px;\n  opacity: 0.95;\n}\n\n.logout-brand img {\n  max-width: 110px;\n  height: auto;\n  filter: drop-shadow(0 4px 10px rgba(0, 0, 0, 0.08));\n}\n\n.logout-countdown {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.logout-countdown-bar {\n  width: 100%;\n  height: 6px;\n  border-radius: 999px;\n  background: rgba(106, 158, 44, 0.15);\n  overflow: hidden;\n}\n\n.logout-countdown-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--clr), var(--clr-hover));\n  border-radius: 999px;\n  transition: width 1s linear;\n}\n\n.logout-countdown span {\n  font-size: 0.78rem;\n  color: #6b6b6b;\n  letter-spacing: 0.02em;\n}\n\n.logout-actions {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: 8px;\n  margin-top: 6px;\n}\n\n.btn-logout-secondary {\n  background: transparent;\n  border: none;\n  color: #7a7a7a;\n  font-size: 0.82rem;\n  cursor: pointer;\n  padding: 6px 8px;\n  border-radius: 8px;\n  transition: color 200ms ease, background-color 200ms ease;\n  letter-spacing: 0.02em;\n}\n\n.btn-logout-secondary:hover {\n  color: var(--clr);\n  background: rgba(106, 158, 44, 0.06);\n}\n\n.logout-footer {\n  width: 100%;\n  text-align: center;\n  padding: 14px 16px;\n  position: relative;\n  z-index: 1;\n  background: rgba(0, 0, 0, 0.55);\n  backdrop-filter: blur(8px);\n  -webkit-backdrop-filter: blur(8px);\n}\n\n.logout-footer span {\n  color: #ffffff;\n  font-size: 0.8rem;\n  letter-spacing: 0.02em;\n  opacity: 0.9;\n}\n\n@media (max-width: 480px) {\n  .logout-card {\n    padding: 34px 22px 26px;\n    border-radius: 20px;\n  }\n  .logout-text h1 { font-size: 1.2rem; }\n  .success-circle { width: 84px; height: 84px; }\n  .success-check  { width: 62px; height: 62px; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
